/* eslint-disable camelcase */
import React from "react"
import { auditShape } from "utils/propTypeShapes"

// There's no unique audit action for a form submission's status changing,
// it's being discarded, or recovered.  All of these use the same "update" action.
// To determine what type of change occurred, we must
// investigate the audited changes.
const changeDescription = (audit) => {
  const { auditedChanges } = audit
  const { discarded_at = [], submission_status_id } = auditedChanges

  const submissionStatusUpdated = Boolean(submission_status_id)
  const submissionRecovered = Boolean(discarded_at[0] && !discarded_at[1])
  const submissionDiscarded = Boolean(!discarded_at[0] && discarded_at[1])

  let updateDescription = "Modified"

  if (submissionStatusUpdated) {
    updateDescription = "Changed"
  } else if (submissionRecovered) {
    updateDescription = "Recovered"
  } else if (submissionDiscarded) {
    updateDescription = "Deleted"
  }

  return updateDescription
}

const FormSubmissionUpdatedAuditItemDetails = ({ audit }) => {
  const { fromStatus, toStatus } = audit

  return (
    <div>
      {changeDescription(audit)}
      { fromStatus && toStatus
       && ` status from ${fromStatus} to ${toStatus}`}
    </div>
  )
}

FormSubmissionUpdatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default FormSubmissionUpdatedAuditItemDetails
